

let times = 0;
let isloop = false;
let needupdatechannelsSet = new Set();

function checkNoticeNum(func) {
  if (isloop == false) {
    isloop = true;
    times = 20;
    abc();
    function abc() {
      setTimeout(async () => {
        if (func) await func()
        times--;
        if (times <= 0) {
          isloop = false;
          times = 0;
          return;
        }
        abc();
      }, 100)
    }
  } else
    times += 1;
}


let getChannelCount = async (channels) => {
  return await window.$app.curl.post("/api/notify/getmsgcount", { channels }, { headers: { core_msgalert: "false" } });
}


export default {
  name: "notify",
  state: {

    channelObj: {},
    moduleNoticeNum: {},
  },

  mutations: {
    // 初始化数据
    initData(state, value) {

      state.channelObj = value;
      this.commit("notify/updatedNoticeNum")
    },

    // 更新频道消息数量
    updatedByChannels(state, res) {
      for (const key in res) {
        state.channelObj[key] = res[key]
      }
      this.commit("notify/updatedNoticeNum")
    },

    // 计算模块对应的消息数
    updatedNoticeNum(state) {
      let tempObj = {}
      for (const [key, allchannels] of Object.entries(this.$app.Cfg.notify.moduleChannelDict)) {
        let noticeNum = 0;
        allchannels.forEach(item => {
          if (state.channelObj[item]) noticeNum += state.channelObj[item]
        })
        tempObj[key] = noticeNum
      }
      state.moduleNoticeNum = tempObj
    }
  },
  actions: {
    async initNotice({ commit, state, dispatch }) {


      let channelset = new Set();
      for (const [key, channels] of Object.entries(this.$app.Cfg.notify.moduleChannelDict)) {
        for (const channel of channels) {
          channelset.add(channel)
        }
      }
      let channels = Array.from(channelset);

      if (channels.length == 0) return
      let res = await getChannelCount(channels);

      commit("initData", res);
      dispatch("monitorChannels");
    },

    async monitorChannels({ commit, state }) {


      Object.keys(state.channelObj).forEach(channel => {
        this.$app.io.on(channel, (res) => {

          console.log("收到频道信息:", channel);
          // 判断是重启循环或者添加热度
          // console.log("监听数量")
          needupdatechannelsSet.add(channel);
          //if(needupdatechannels.indexOf(channel) == -1) needupdatechannels.push(channel);    
          checkNoticeNum(async () => {
            if (needupdatechannelsSet.size == 0) return;
            let arr = Array.from(needupdatechannelsSet);
            needupdatechannelsSet.clear();
            getChannelCount(arr).then(res => {
              commit("updatedByChannels", res)
              // console.log(res)
            }).catch(() => { })
            // needupdatechannels = [];
          });

        });
      })

    },

  },
}



